import {
    ADD_MEDIA_NODE_DIALOG_HIDE,
    ADD_MEDIA_NODE_DIALOG_SHOW,
    ADD_MEDIA_NODE_ERROR,
    ADD_MEDIA_NODE_IN_PROGRESS,
    ADD_MEDIA_NODE_SUCCESS,
    CONNECT_MEDIA_NODE_ERROR,
    CONNECT_MEDIA_NODE_IN_PROGRESS,
    CONNECT_MEDIA_NODE_SUCCESS,
    DELETE_MEDIA_NODE_DIALOG_HIDE,
    DELETE_MEDIA_NODE_DIALOG_SHOW,
    DELETE_MEDIA_NODE_ERROR,
    DELETE_MEDIA_NODE_IN_PROGRESS,
    DELETE_MEDIA_NODE_SUCCESS,
    MEDIA_NODE_ACCESS_TOKEN_FETCH_ERROR,
    MEDIA_NODE_ACCESS_TOKEN_FETCH_IN_PROGRESS,
    MEDIA_NODE_ACCESS_TOKEN_FETCH_SUCCESS,
    MEDIA_NODE_AUTH_TOKEN_SET,
    MEDIA_NODE_DESCRIPTION_SET,
    MEDIA_NODE_DETAILS_FETCH_ERROR,
    MEDIA_NODE_DETAILS_FETCH_IN_PROGRESS,
    MEDIA_NODE_DETAILS_FETCH_SUCCESS,
    MEDIA_NODE_DETAILS_SET,
    MEDIA_NODE_NAME_SET,
    MEDIA_NODE_PROFILE_DETAILS_FETCH_ERROR,
    MEDIA_NODE_PROFILE_DETAILS_FETCH_IN_PROGRESS,
    MEDIA_NODE_PROFILE_DETAILS_FETCH_SUCCESS,
    MEDIA_NODE_STATUS_FETCH_ERROR,
    MEDIA_NODE_STATUS_FETCH_IN_PROGRESS,
    MEDIA_NODE_STATUS_FETCH_SUCCESS,
    MEDIA_NODE_UPLOAD_ACCESS_TOKEN_SET,
    MEDIA_NODE_URL_SET,
    MEDIA_NODES_FETCH_ERROR,
    MEDIA_NODES_FETCH_IN_PROGRESS,
    MEDIA_NODES_FETCH_SUCCESS,
    UPDATE_MEDIA_NODE_DIALOG_HIDE,
    UPDATE_MEDIA_NODE_DIALOG_SHOW,
    UPDATE_MEDIA_NODE_ERROR,
    UPDATE_MEDIA_NODE_IN_PROGRESS,
    UPDATE_MEDIA_NODE_SUCCESS,
    VERIFY_MEDIA_NODE_ERROR,
    VERIFY_MEDIA_NODE_IN_PROGRESS,
    VERIFY_MEDIA_NODE_SUCCESS,
    LIVE_STREAM_ACCESS_TOKEN_FETCH_ERROR,
    LIVE_STREAM_ACCESS_TOKEN_FETCH_IN_PROGRESS,
    LIVE_STREAM_ACCESS_TOKEN_FETCH_SUCCESS,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_ERROR,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_IN_PROGRESS,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_SUCCESS,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_SHOW,
    UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_HIDE,
    CHANNEL_AUTH_ENABLE_IN_PROGRESS,
    CHANNEL_AUTH_ENABLE_SUCCESS,
    CHANNEL_AUTH_ENABLE_ERROR,
    CHANNEL_AUTH_DISABLE_IN_PROGRESS,
    CHANNEL_AUTH_DISABLE_SUCCESS,
    CHANNEL_AUTH_DISABLE_ERROR,
    O_AUTH_DIALOG_SHOW,
    O_AUTH_DIALOG_HIDE,
    YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR,
    YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS,
    YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS,
    YOUTUBE_O_AUTH_URL_FETCH_ERROR,
    YOUTUBE_O_AUTH_URL_FETCH_SUCCESS,
    TWITCH_O_AUTH_URL_FETCH_SUCCESS,
    TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS,
    TWITCH_O_AUTH_URL_FETCH_ERROR,
    TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS,
    TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    TWITCH_O_AUTH_CALLBACK_FETCH_ERROR,
    FACEBOOK_O_AUTH_URL_FETCH_SUCCESS,
    FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS,
    FACEBOOK_O_AUTH_URL_FETCH_ERROR,
    FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS,
    FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR,
    MEDIA_NODE_ID_SET,
    MEDIA_NODE_CHECK_CONFIG_FETCH_ERROR,
    MEDIA_NODE_CHECK_CONFIG_FETCH_IN_PROGRESS,
    MEDIA_NODE_CHECK_CONFIG_FETCH_SUCCESS,
    MEDIA_NODE_ASSETS_LIST_FETCH_IN_PROGRESS,
    MEDIA_NODE_ASSETS_LIST_FETCH_SUCCESS,
    MEDIA_NODE_ASSETS_LIST_FETCH_ERROR,
    MEDIA_NODE_ASSET_DELETE_DIALOG_SHOW,
    MEDIA_NODE_ASSET_DELETE_DIALOG_HIDE,
    MEDIA_NODE_ASSET_DELETE_IN_PROGRESS,
    MEDIA_NODE_ASSET_DELETE_SUCCESS,
    MEDIA_NODE_ASSET_DELETE_ERROR,
    MEDIA_NODE_ASSET_UPLOAD_DIALOG_HIDE,
    MEDIA_NODE_ASSET_UPLOAD_DIALOG_SHOW,
    MEDIA_NODE_CATEGORIES_LIST_FETCH_IN_PROGRESS,
    MEDIA_NODE_CATEGORIES_LIST_FETCH_SUCCESS,
    MEDIA_NODE_CATEGORIES_LIST_FETCH_ERROR,
    MEDIA_NODE_CATEGORIE_VALUE_SET,
    UPLOAD_MEDIA_NODE_ASSET_FILE_ERROR_MESSAGE_SET,
    UPLOAD_MEDIA_NODE_ASSET_FILE_CANCEL_SET,
    MEDIA_NODE_ASSET_UPLOAD_SET,
    MEDIA_NODE_ASSET_UPLOAD_IN_PROGRESS,
    MEDIA_NODE_ASSET_UPLOAD_SUCCESS,
    MEDIA_NODE_ASSET_UPLOAD_ERROR,
    MEDIA_NODE_ASSET_UPLOAD_PROGRESS_SET,
    MEDIA_NODE_ASSET_UPLOAD_CANCEL_SET,
    UPLOAD_MEDIA_NODE_CATEGORY_ERROR,
    UPLOAD_MEDIA_NODE_CATEGORY_SUCCESS,
    UPLOAD_MEDIA_NODE_CATEGORY_IN_PROGRESS,
    MEDIA_NODE_EDIT_DIALOG_SHOW,
    MEDIA_NODE_EDIT_DIALOG_HIDE,
} from '../../constants/mediaNodes';
import {
    urlAddMediaNode,
    urlDeleteMediaNode,
    urlDisableChannelAuth,
    urlEnableChannelAuth,
    urlFetchMediaNodeAssetsList,
    urlFetchMediaNodeDetails,
    urlFetchMediaNodes,
    urlLeaseMediaNode,
    urlLiveStreamAccessToken,
    urlUpdateLiveStreamAccessToken,
    urlDeleteMediaNodeAsset,
    urlFetchMediaNodeCategoriesList,
    urlUpdateMediaNodeAsset,
    urlUpdateMediaNodeRunner,
} from '../../constants/url';
import Axios from 'axios';
import { handleErrorMessage } from '../../utils/errorMessages';
import {
    urlConnectMediaNode,
    urlFetchMediaNodeAccessToken,
    urlFetchMediaNodeStatus,
    urlFetchProfileDetails,
    urlVerifyMediaNode,
    urlMediaNodeCheckConfig,
    urlYoutubeOAuth,
    urlYoutubeOAuthCallback,
    urlTwitchOAuth,
    urlTwitchOAuthCallback,
    urlFacebookOAuth,
    urlFacebookOAuthCallback,
} from '../../constants/mediaNodes/url';
import { getAssetType } from '../../utils/strings';

export const setMediaNodeName = (value) => {
    return {
        type: MEDIA_NODE_NAME_SET,
        value,
    };
};

export const setMediaNodeID = (value, valid) => {
    return {
        type: MEDIA_NODE_ID_SET,
        value,
        valid,
    };
};

export const setMediaNodeDescription = (value, valid) => {
    return {
        type: MEDIA_NODE_DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setMediaNodeUrl = (value, valid) => {
    return {
        type: MEDIA_NODE_URL_SET,
        value,
        valid,
    };
};

export const setMediaNodeAuthToken = (value) => {
    return {
        type: MEDIA_NODE_AUTH_TOKEN_SET,
        value,
    };
};

export const setMediaNodeAccessToken = (value) => {
    return {
        type: MEDIA_NODE_UPLOAD_ACCESS_TOKEN_SET,
        value,
    };
};

export const showAddMediaNodeDialog = (value) => {
    return {
        type: ADD_MEDIA_NODE_DIALOG_SHOW,
        value,
    };
};

export const hideAddMediaNodeDialog = () => {
    return {
        type: ADD_MEDIA_NODE_DIALOG_HIDE,
    };
};

export const showUpdateMediaNodeDialog = (value) => {
    return {
        type: UPDATE_MEDIA_NODE_DIALOG_SHOW,
        value,
    };
};

export const hideUpdateMediaNodeDialog = () => {
    return {
        type: UPDATE_MEDIA_NODE_DIALOG_HIDE,
    };
};

export const showDeleteMediaNodeDialog = (value) => {
    return {
        type: DELETE_MEDIA_NODE_DIALOG_SHOW,
        value,
    };
};

export const hideDeleteMediaNodeDialog = () => {
    return {
        type: DELETE_MEDIA_NODE_DIALOG_HIDE,
    };
};

const fetchMediaNodesInProgress = () => {
    return {
        type: MEDIA_NODES_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodesSuccess = (value, skip, limit, total) => {
    return {
        type: MEDIA_NODES_FETCH_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchMediaNodesError = (message) => {
    return {
        type: MEDIA_NODES_FETCH_ERROR,
        message,
    };
};

export const fetchMediaNodes = (skip, limit, cb) => (dispatch) => {
    dispatch(fetchMediaNodesInProgress());

    const url = urlFetchMediaNodes(skip, limit);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodesSuccess(res.data && res.data.result,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodesError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchMediaNodeDetailsInProgress = () => {
    return {
        type: MEDIA_NODE_DETAILS_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodeDetailsSuccess = (value, id) => {
    return {
        type: MEDIA_NODE_DETAILS_FETCH_SUCCESS,
        value,
        id,
    };
};

const fetchMediaNodeDetailsError = (message) => {
    return {
        type: MEDIA_NODE_DETAILS_FETCH_ERROR,
        message,
    };
};

export const fetchMediaNodeDetails = (id, cb) => (dispatch) => {
    dispatch(fetchMediaNodeDetailsInProgress());

    const url = urlFetchMediaNodeDetails(id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodeDetailsSuccess(res.data && res.data.result, id));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeDetailsError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const setMediaNodeDetails = (value) => {
    return {
        type: MEDIA_NODE_DETAILS_SET,
        value,
    };
};

const addMediaNodeInProgress = () => {
    return {
        type: ADD_MEDIA_NODE_IN_PROGRESS,
    };
};

const addMediaNodeSuccess = (value, message) => {
    return {
        type: ADD_MEDIA_NODE_SUCCESS,
        value,
        message,
    };
};

const addMediaNodeError = (message) => {
    return {
        type: ADD_MEDIA_NODE_ERROR,
        message,
    };
};

export const addMediaNode = (data, cb) => (dispatch) => {
    dispatch(addMediaNodeInProgress());

    const url = urlAddMediaNode();
    Axios.post(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(addMediaNodeSuccess(res.data && res.data.result, 'Media Node Added Successfully'));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addMediaNodeError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const leaseMediaNode = (data, cb) => (dispatch) => {
    dispatch(addMediaNodeInProgress());

    const url = urlLeaseMediaNode();
    Axios.post(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(addMediaNodeSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addMediaNodeError(message));
            if (cb) {
                cb(null);
            }
        });
};

const updateMediaNodeInProgress = () => {
    return {
        type: UPDATE_MEDIA_NODE_IN_PROGRESS,
    };
};

const updateMediaNodeSuccess = (value, message) => {
    return {
        type: UPDATE_MEDIA_NODE_SUCCESS,
        value,
        message,
    };
};

const updateMediaNodeError = (message) => {
    return {
        type: UPDATE_MEDIA_NODE_ERROR,
        message,
    };
};

export const updateMediaNode = (id, data, cb) => (dispatch) => {
    dispatch(updateMediaNodeInProgress());

    const url = urlDeleteMediaNode(id);
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(updateMediaNodeSuccess(res.data && res.data.result, 'Media Node Updated Successfully'));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateMediaNodeError(message));
            if (cb) {
                cb(null);
            }
        });
};

// const fetchChannelInfoInProgress = () => {
//     return {
//         type: FETCH_CHANNEL_INFO_IN_PROGRESS,
//     };
// };

// const fetchChannelInfoSuccess = (value) => {
//     return {
//         type: FETCH_CHANNEL_INFO_SUCCESS,
//         value,
//     };
// };

// const fetchChannelInfoError = (message) => {
//     return {
//         type: FETCH_CHANNEL_INFO_ERROR,
//         message,
//     };
// };

// export const fetchChannelInfo = (id, cb) => (dispatch) => {
//     dispatch(fetchChannelInfoInProgress());

//     const url = urlFetchChannel(id);
//     Axios.get(url, {
//         headers: {
//             Accept: 'application/json, text/plain, */*',
//             Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
//         },
//     })
//         .then((res) => {
//             dispatch(fetchChannelInfoSuccess(res.data && res.data.result));
//             if (cb) {
//                 cb(res.data && res.data.result);
//             }
//         })
//         .catch((error) => {
//             const message = handleErrorMessage(error);
//             dispatch(fetchChannelInfoError(message));
//             if (cb) {
//                 cb(null);
//             }
//         });
// };

const deleteMediaNodeInProgress = () => {
    return {
        type: DELETE_MEDIA_NODE_IN_PROGRESS,
    };
};

const deleteMediaNodeSuccess = (value, message) => {
    return {
        type: DELETE_MEDIA_NODE_SUCCESS,
        value,
        message,
    };
};

const deleteMediaNodeError = (message) => {
    return {
        type: DELETE_MEDIA_NODE_ERROR,
        message,
    };
};

export const deleteMediaNode = (id, cb) => (dispatch) => {
    dispatch(deleteMediaNodeInProgress());

    const URL = urlDeleteMediaNode(id);
    Axios.delete(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(deleteMediaNodeSuccess(res.data, 'Media Node Deleted Successfully'));
            if (cb) {
                cb(res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(deleteMediaNodeError(message));
            if (cb) {
                cb(null);
            }
        });
};

const connectMediaNodeInProgress = () => {
    return {
        type: CONNECT_MEDIA_NODE_IN_PROGRESS,
    };
};

const connectMediaNodeSuccess = (value) => {
    return {
        type: CONNECT_MEDIA_NODE_SUCCESS,
        value,
    };
};

const connectMediaNodeError = (message) => {
    return {
        type: CONNECT_MEDIA_NODE_ERROR,
        message,
        variant: 'error',
    };
};

export const connectMediaNode = (url, data, cb) => (dispatch) => {
    dispatch(connectMediaNodeInProgress());

    const URL = urlConnectMediaNode(url);
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(connectMediaNodeSuccess(res.data.result));
            cb(res.data.result);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(connectMediaNodeError(message));

            cb(null, message);
        });
};

const verifyMediaNodeInProgress = () => {
    return {
        type: VERIFY_MEDIA_NODE_IN_PROGRESS,
    };
};

const verifyMediaNodeSuccess = (message, value) => {
    return {
        type: VERIFY_MEDIA_NODE_SUCCESS,
        message,
        value,
    };
};

const verifyMediaNodeError = (message) => {
    return {
        type: VERIFY_MEDIA_NODE_ERROR,
        message,
        variant: 'error',
    };
};

export const verifyMediaNode = (url, nodeID, mediaNodeID, userId, data, cb) => (dispatch) => {
    dispatch(verifyMediaNodeInProgress());

    const URL = urlVerifyMediaNode(url, userId);
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(verifyMediaNodeSuccess('Success', res.data && res.data.result['access_token']));
            localStorage.setItem(`acToken_of_studio_media_node_${nodeID}`, res.data && res.data.result['access_token']);
            localStorage.setItem(`rfToken_of_studio_media_node_${nodeID}`, res.data && res.data.result['refresh_token']);
            localStorage.setItem('active_of_studio_media_node', nodeID);
            if (mediaNodeID) {
                localStorage.setItem('active_of_studio_media_node_id', mediaNodeID);
            }
            if (localStorage.getItem('connected_media_nodes')) {
                const storedMediaNodes = JSON.parse(localStorage.getItem('connected_media_nodes'));
                storedMediaNodes.push(mediaNodeID);
                localStorage.setItem('connected_media_nodes', JSON.stringify(storedMediaNodes));
            } else {
                const storedMediaNodes = [];
                storedMediaNodes.push(mediaNodeID);
                localStorage.setItem('connected_media_nodes', JSON.stringify(storedMediaNodes));
            }
            cb(null);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(verifyMediaNodeError(message));

            cb(message);
        });
};

const fetchMediaNodeProfileDetailsInProgress = () => {
    return {
        type: MEDIA_NODE_PROFILE_DETAILS_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodeProfileDetailsSuccess = (value) => {
    return {
        type: MEDIA_NODE_PROFILE_DETAILS_FETCH_SUCCESS,
        value,
    };
};

const fetchMediaNodeProfileDetailsError = (message, url, nodeID) => {
    return {
        type: MEDIA_NODE_PROFILE_DETAILS_FETCH_ERROR,
        message,
        url,
        nodeID,
        variant: 'error',
    };
};

export const fetchMediaNodeProfileDetails = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchMediaNodeProfileDetailsInProgress());

    const URL = urlFetchProfileDetails(url);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodeProfileDetailsSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeProfileDetailsError(message, url, nodeID));
            if (cb) {
                cb(error);
            }
        });
};

const fetchMediaNodeAccessTokenInProgress = () => {
    return {
        type: MEDIA_NODE_ACCESS_TOKEN_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodeAccessTokenSuccess = (value) => {
    return {
        type: MEDIA_NODE_ACCESS_TOKEN_FETCH_SUCCESS,
        value,
    };
};

const fetchMediaNodeAccessTokenError = (message) => {
    return {
        type: MEDIA_NODE_ACCESS_TOKEN_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchMediaNodeAccessToken = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchMediaNodeAccessTokenInProgress());

    const URL = urlFetchMediaNodeAccessToken(url);
    const data = {
        refreshToken: localStorage.getItem(`rfToken_of_studio_media_node_${nodeID}`),
    };

    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            localStorage.setItem(`acToken_of_studio_media_node_${nodeID}`, res.data && res.data.result['access_token']);
            localStorage.setItem(`rfToken_of_studio_media_node_${nodeID}`, res.data && res.data.result['refresh_token']);
            dispatch(fetchMediaNodeAccessTokenSuccess('Success', res.data && res.data.result['access_token']));
            if (cb) {
                cb(null);
            }
        })
        .catch((error) => {
            localStorage.removeItem(`acToken_of_studio_media_node_${nodeID}`);
            localStorage.removeItem(`rfToken_of_studio_media_node_${nodeID}`);
            if (localStorage.getItem('active_of_studio_media_node')) {
                localStorage.removeItem('active_of_studio_media_node');
            }
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeAccessTokenError(message, url, nodeID));
            if (cb) {
                cb(error);
            }
        });
};

const fetchMediaNodeStatusInProgress = () => {
    return {
        type: MEDIA_NODE_STATUS_FETCH_IN_PROGRESS,
    };
};

export const fetchMediaNodeStatusSuccess = (value, nodeID) => {
    return {
        type: MEDIA_NODE_STATUS_FETCH_SUCCESS,
        value,
        nodeID,
    };
};

const fetchMediaNodeStatusError = (message) => {
    return {
        type: MEDIA_NODE_STATUS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchMediaNodeStatus = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchMediaNodeStatusInProgress());

    const URL = urlFetchMediaNodeStatus(url);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodeStatusSuccess(res.data && res.data.result, nodeID));
            if (cb) {
                cb(null);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeStatusError(message));
            if (cb) {
                cb(error);
            }
        });
};

const fetchLiveStreamAccessTokenInProgress = () => {
    return {
        type: LIVE_STREAM_ACCESS_TOKEN_FETCH_IN_PROGRESS,
    };
};

const fetchLiveStreamAccessTokenSuccess = (value) => {
    return {
        type: LIVE_STREAM_ACCESS_TOKEN_FETCH_SUCCESS,
        value,
    };
};

const fetchLiveStreamAccessTokenError = (message) => {
    return {
        type: LIVE_STREAM_ACCESS_TOKEN_FETCH_ERROR,
        message,
    };
};

export const fetchLiveStreamAccessToken = (cb) => (dispatch) => {
    dispatch(fetchLiveStreamAccessTokenInProgress());

    const url = urlLiveStreamAccessToken();
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchLiveStreamAccessTokenSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLiveStreamAccessTokenError(message));
            if (cb) {
                cb(null);
            }
        });
};

const updateLiveStreamAccessTokenInProgress = () => {
    return {
        type: UPDATE_LIVE_STREAM_ACCESS_TOKEN_IN_PROGRESS,
    };
};

const updateLiveStreamAccessTokenSuccess = (value) => {
    return {
        type: UPDATE_LIVE_STREAM_ACCESS_TOKEN_SUCCESS,
        value,
    };
};

const updateLiveStreamAccessTokenError = (message) => {
    return {
        type: UPDATE_LIVE_STREAM_ACCESS_TOKEN_ERROR,
        message,
    };
};

export const updateLiveStreamAccessToken = (URL, nodeID, id, data, cb) => (dispatch) => {
    dispatch(updateLiveStreamAccessTokenInProgress());

    const url = urlUpdateLiveStreamAccessToken(URL, id);
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(updateLiveStreamAccessTokenSuccess(res.data && res.data.result, nodeID));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateLiveStreamAccessTokenError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const showLiveStreamUpdateAccessTokenDialog = () => {
    return {
        type: UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_SHOW,
    };
};

export const hideLiveStreamUpdateAccessTokenDialog = () => {
    return {
        type: UPDATE_LIVE_STREAM_ACCESS_TOKEN_DIALOG_HIDE,
    };
};

const enableChannelAuthInProgress = () => {
    return {
        type: CHANNEL_AUTH_ENABLE_IN_PROGRESS,
    };
};

const enableChannelAuthSuccess = (value) => {
    return {
        type: CHANNEL_AUTH_ENABLE_SUCCESS,
        value,
    };
};

const enableChannelAuthError = (message) => {
    return {
        type: CHANNEL_AUTH_ENABLE_ERROR,
        message,
    };
};

export const enableChannelAuth = (URL, nodeID, id, channelID, cb) => (dispatch) => {
    dispatch(enableChannelAuthInProgress());

    const url = urlEnableChannelAuth(URL, id, channelID);
    Axios.put(url, {}, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(enableChannelAuthSuccess(res.data && res.data.result, nodeID));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(enableChannelAuthError(message));
            if (cb) {
                cb(null);
            }
        });
};

const disableChannelAuthInProgress = () => {
    return {
        type: CHANNEL_AUTH_DISABLE_IN_PROGRESS,
    };
};

const disableChannelAuthSuccess = (value) => {
    return {
        type: CHANNEL_AUTH_DISABLE_SUCCESS,
        value,
    };
};

const disableChannelAuthError = (message) => {
    return {
        type: CHANNEL_AUTH_DISABLE_ERROR,
        message,
    };
};

export const disableChannelAuth = (URL, nodeID, id, channelID, cb) => (dispatch) => {
    dispatch(disableChannelAuthInProgress());

    const url = urlDisableChannelAuth(URL, id, channelID);
    Axios.put(url, {}, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(disableChannelAuthSuccess(res.data && res.data.result, nodeID));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(disableChannelAuthError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const showOAuthDialog = () => {
    return {
        type: O_AUTH_DIALOG_SHOW,
    };
};

export const hideOAuthDialog = () => {
    return {
        type: O_AUTH_DIALOG_HIDE,
    };
};

// OAuth

const fetchYoutubeOAuthUrlInProgress = () => {
    return {
        type: YOUTUBE_O_AUTH_URL_FETCH_IN_PROGRESS,
    };
};

const fetchYoutubeOAuthUrlSuccess = (value) => {
    return {
        type: YOUTUBE_O_AUTH_URL_FETCH_SUCCESS,
        value,
    };
};

const fetchYoutubeOAuthUrlError = (message) => {
    return {
        type: YOUTUBE_O_AUTH_URL_FETCH_ERROR,
        message,
    };
};

export const fetchYoutubeOAuthUrl = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchYoutubeOAuthUrlInProgress());

    const URL = urlYoutubeOAuth(url);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchYoutubeOAuthUrlSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchYoutubeOAuthUrlError(message));
            if (cb) {
                cb(error);
            }
        });
};

const fetchYoutubeOAuthCallbackInProgress = () => {
    return {
        type: YOUTUBE_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    };
};

const fetchYoutubeOAuthCallbackSuccess = (value) => {
    return {
        type: YOUTUBE_O_AUTH_CALLBACK_FETCH_SUCCESS,
        value,
    };
};

const fetchYoutubeOAuthCallbackError = (message) => {
    return {
        type: YOUTUBE_O_AUTH_CALLBACK_FETCH_ERROR,
        message,
    };
};

export const fetchYoutubeOAuthCallback = (url, nodeID, code, scope, state, cb) => (dispatch) => {
    dispatch(fetchYoutubeOAuthCallbackInProgress());

    const URL = urlYoutubeOAuthCallback(url, code, scope, state);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchYoutubeOAuthCallbackSuccess(res && res.data));
            if (cb) {
                cb(res && res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchYoutubeOAuthCallbackError(message));
            if (cb) {
                cb(error);
            }
        });
};

// Twitch OAuth
const fetchTwitchOAuthUrlInProgress = () => {
    return {
        type: TWITCH_O_AUTH_URL_FETCH_IN_PROGRESS,
    };
};

const fetchTwitchOAuthUrlSuccess = (value) => {
    return {
        type: TWITCH_O_AUTH_URL_FETCH_SUCCESS,
        value,
    };
};

const fetchTwitchOAuthUrlError = (message) => {
    return {
        type: TWITCH_O_AUTH_URL_FETCH_ERROR,
        message,
    };
};

export const fetchTwitchOAuthUrl = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchTwitchOAuthUrlInProgress());

    const URL = urlTwitchOAuth(url);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchTwitchOAuthUrlSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchTwitchOAuthUrlError(message));
            if (cb) {
                cb(error);
            }
        });
};

const fetchTwitchOAuthCallbackInProgress = () => {
    return {
        type: TWITCH_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    };
};

const fetchTwitchOAuthCallbackSuccess = (value) => {
    return {
        type: TWITCH_O_AUTH_CALLBACK_FETCH_SUCCESS,
        value,
    };
};

const fetchTwitchOAuthCallbackError = (message) => {
    return {
        type: TWITCH_O_AUTH_CALLBACK_FETCH_ERROR,
        message,
    };
};

export const fetchTwitchOAuthCallback = (url, nodeID, code, scope, state, cb) => (dispatch) => {
    dispatch(fetchTwitchOAuthCallbackInProgress());

    const URL = urlTwitchOAuthCallback(url, code, scope, state);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchTwitchOAuthCallbackSuccess(res && res.data));
            if (cb) {
                cb(res && res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchTwitchOAuthCallbackError(message));
            if (cb) {
                cb(error);
            }
        });
};

// Facebook OAuth

const fetchFacebookOAuthUrlInProgress = () => {
    return {
        type: FACEBOOK_O_AUTH_URL_FETCH_IN_PROGRESS,
    };
};

const fetchFacebookOAuthUrlSuccess = (value) => {
    return {
        type: FACEBOOK_O_AUTH_URL_FETCH_SUCCESS,
        value,
    };
};

const fetchFacebookOAuthUrlError = (message) => {
    return {
        type: FACEBOOK_O_AUTH_URL_FETCH_ERROR,
        message,
    };
};

export const fetchFacebookOAuthUrl = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchFacebookOAuthUrlInProgress());

    const URL = urlFacebookOAuth(url);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchFacebookOAuthUrlSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchFacebookOAuthUrlError(message));
            if (cb) {
                cb(error);
            }
        });
};

const fetchFacebookOAuthCallbackInProgress = () => {
    return {
        type: FACEBOOK_O_AUTH_CALLBACK_FETCH_IN_PROGRESS,
    };
};

const fetchFacebookOAuthCallbackSuccess = (value) => {
    return {
        type: FACEBOOK_O_AUTH_CALLBACK_FETCH_SUCCESS,
        value,
    };
};

const fetchFacebookOAuthCallbackError = (message) => {
    return {
        type: FACEBOOK_O_AUTH_CALLBACK_FETCH_ERROR,
        message,
    };
};

export const fetchFacebookOAuthCallback = (url, nodeID, code, state, cb) => (dispatch) => {
    dispatch(fetchFacebookOAuthCallbackInProgress());

    const URL = urlFacebookOAuthCallback(url, code, state);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchFacebookOAuthCallbackSuccess(res && res.data));
            if (cb) {
                cb(res && res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchFacebookOAuthCallbackError(message));
            if (cb) {
                cb(error);
            }
        });
};

// Check Config
const fetchMediaNodeCheckConfigInProgress = () => {
    return {
        type: MEDIA_NODE_CHECK_CONFIG_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodeCheckConfigSuccess = (value) => {
    return {
        type: MEDIA_NODE_CHECK_CONFIG_FETCH_SUCCESS,
        value,
    };
};

const fetchMediaNodeCheckConfigError = (message) => {
    return {
        type: MEDIA_NODE_CHECK_CONFIG_FETCH_ERROR,
        message,
    };
};

export const fetchMediaNodeCheckConfig = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchMediaNodeCheckConfigInProgress());

    const URL = urlMediaNodeCheckConfig(url);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodeCheckConfigSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeCheckConfigError(message));
            if (cb) {
                cb(error);
            }
        });
};

// MEDIA NODE ASSETS
const fetchMediaNodeAssetsInProgress = () => {
    return {
        type: MEDIA_NODE_ASSETS_LIST_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodeAssetsSuccess = (value, skip, limit, total) => {
    return {
        type: MEDIA_NODE_ASSETS_LIST_FETCH_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchMediaNodeAssetsError = (message) => {
    return {
        type: MEDIA_NODE_ASSETS_LIST_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchMediaNodeAssets = (nodeID, apiURL, skip, limit, cb) => (dispatch) => {
    dispatch(fetchMediaNodeAssetsInProgress());

    const url = urlFetchMediaNodeAssetsList(apiURL, skip, limit);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodeAssetsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeAssetsError(message));
            if (cb) {
                cb(error);
            }
        });
};

export const showDeleteMediaNodeAssetDialog = (value) => {
    return {
        type: MEDIA_NODE_ASSET_DELETE_DIALOG_SHOW,
        value,
    };
};

export const hideDeleteMediaNodeAssetDialog = () => {
    return {
        type: MEDIA_NODE_ASSET_DELETE_DIALOG_HIDE,
    };
};

const deleteMediaNodeAssetInProgress = () => {
    return {
        type: MEDIA_NODE_ASSET_DELETE_IN_PROGRESS,
    };
};

const deleteMediaNodeAssetSuccess = (value, message) => {
    return {
        type: MEDIA_NODE_ASSET_DELETE_SUCCESS,
        value,
        message,
    };
};

const deleteMediaNodeAssetError = (message) => {
    return {
        type: MEDIA_NODE_ASSET_DELETE_ERROR,
        message,
    };
};

export const deleteMediaNodeAsset = (nodeID, apiURL, id, cb) => (dispatch) => {
    dispatch(deleteMediaNodeAssetInProgress());

    const data = {
        id: id,
        source: true,
        encoded: true,
    };
    const URL = urlDeleteMediaNodeAsset(apiURL, id);
    Axios.delete(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
        data: data,
    })
        .then((res) => {
            dispatch(deleteMediaNodeAssetSuccess(res.data, 'Media Node Asset Deleted Successfully'));
            if (cb) {
                cb(res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(deleteMediaNodeAssetError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const showUploadMediaNodeAssetDialog = (value) => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_DIALOG_SHOW,
        value,
    };
};

export const hideUploadMediaNodeAssetDialog = () => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_DIALOG_HIDE,
    };
};

export const setUploadMediaNodeAssetFileValid = () => {
    return {
        type: UPLOAD_MEDIA_NODE_ASSET_FILE_ERROR_MESSAGE_SET,
    };
};

export const setCancelUploadMediaNodeAsset = (list) => {
    return {
        type: UPLOAD_MEDIA_NODE_ASSET_FILE_CANCEL_SET,
        list,
    };
};

export const setMediaNodeAssetUpload = (value, list) => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_SET,
        value,
        list,
    };
};

const uploadMediaNodeAssetInProgress = () => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_IN_PROGRESS,
    };
};

const uploadMediaNodeAssetSuccess = (data, id) => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_SUCCESS,
        message: 'Uploaded',
        id,
    };
};

const uploadMediaNodeAssetError = (message) => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_ERROR,
        message,
        variant: 'error',
    };
};

const setUploadMediaNodeAssetProgress = (value, ID) => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_PROGRESS_SET,
        value,
        ID,
    };
};

export const uploadMediaNodeAssetCancel = (cancel, ID) => {
    return {
        type: MEDIA_NODE_ASSET_UPLOAD_CANCEL_SET,
        cancel,
        ID,
    };
};

export const uploadMediaNodeAsset = (nodeID, apiURL, profileID, assetID, file, ID, cb) => (dispatch) => {
    dispatch(uploadMediaNodeAssetInProgress());

    const CancelToken = Axios.CancelToken;
    const formData = new FormData();
    formData.append('_type', getAssetType(file.type));
    formData.append('file', file);

    const URL = urlUpdateMediaNodeRunner(apiURL, profileID, assetID);
    Axios.post(URL, formData, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
        onUploadProgress: (progressEvent) => {
            dispatch(setUploadMediaNodeAssetProgress(progressEvent, ID));
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(uploadMediaNodeAssetCancel(cancel, ID));
        }),
    })
        .then((res) => {
            dispatch(uploadMediaNodeAssetSuccess(res.data && res.data.asset, ID));
            cb(null, res.data && res.data.asset);
        })
        .catch((error) => {
            const message = handleErrorMessage(error, 'Canceled File Upload!');
            dispatch(uploadMediaNodeAssetError(message));
            cb(error, null);
        });
};

export const reUploadMediaNodeAsset = (nodeID, apiURL, id, file, assetID, ID, cb) => (dispatch) => {
    dispatch(uploadMediaNodeAssetInProgress());

    const CancelToken = Axios.CancelToken;
    const formData = new FormData();
    formData.append('_type', getAssetType(file.type));
    formData.append('file', file);

    const URL = urlUpdateMediaNodeRunner(apiURL, id, assetID);
    Axios.post(URL, formData, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
        onUploadProgress: (progressEvent) => {
            dispatch(setUploadMediaNodeAssetProgress(progressEvent, ID));
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(uploadMediaNodeAssetCancel(cancel, ID));
        }),
    })
        .then((res) => {
            dispatch(uploadMediaNodeAssetSuccess(res.data.result));
            cb(null);
        })
        .catch((error) => {
            const message = handleErrorMessage(error, 'Canceled File Upload!');
            dispatch(uploadMediaNodeAssetError(message));
            cb(error);
        });
};

export const setMediaNodeCategoryValue = (value) => {
    return {
        type: MEDIA_NODE_CATEGORIE_VALUE_SET,
        value,
    };
};

const fetchMediaNodeCategoriesInProgress = () => {
    return {
        type: MEDIA_NODE_CATEGORIES_LIST_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodeCategoriesSuccess = (value, skip, limit, total) => {
    return {
        type: MEDIA_NODE_CATEGORIES_LIST_FETCH_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchMediaNodeCategoriesError = (message) => {
    return {
        type: MEDIA_NODE_CATEGORIES_LIST_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchMediaNodeCategories = (nodeID, apiURL, skip, limit, cb) => (dispatch) => {
    dispatch(fetchMediaNodeCategoriesInProgress());

    const url = urlFetchMediaNodeCategoriesList(apiURL, skip, limit);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodeCategoriesSuccess(res.data && res.data.result,
                skip, limit, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result, res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeCategoriesError(message));
            if (cb) {
                cb(error);
            }
        });
};

const uploadMediaNodeCategoryInProgress = () => {
    return {
        type: UPLOAD_MEDIA_NODE_CATEGORY_IN_PROGRESS,
    };
};

const uploadMediaNodeCategorySuccess = (value) => {
    return {
        type: UPLOAD_MEDIA_NODE_CATEGORY_SUCCESS,
        value,
    };
};

const uploadMediaNodeCategoryError = (message) => {
    return {
        type: UPLOAD_MEDIA_NODE_CATEGORY_ERROR,
        message,
        variant: 'error',
    };
};

export const uploadMediaNodeCategory = (nodeID, apiURL, data, cb) => (dispatch) => {
    dispatch(uploadMediaNodeCategoryInProgress());

    const URL = urlUpdateMediaNodeAsset(apiURL);
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(uploadMediaNodeCategorySuccess(res.data.result));
            cb(res.data.result);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(uploadMediaNodeCategoryError(message));

            cb(null, message);
        });
};

export const editMediaNodeDialogShow = () => {
    return {
        type: MEDIA_NODE_EDIT_DIALOG_SHOW,
    };
};

export const editMediaNodeDialogHide = () => {
    return {
        type: MEDIA_NODE_EDIT_DIALOG_HIDE,
    };
};
